module.exports = __webpack_public_path__ + "img/deals.a9dc5a01.svg";